import { useMutation, useQueryClient } from '@tanstack/react-query'
import { CommentsHttpClient } from '@omnea-app/comments/commentsHttpClient'
import { supplierPortalPath } from '@omnea-app/fe-api-client/supplierPortalPath'
import { useAuthenticatedUser, useIsSupplierRole } from '@omnea-app/fe-auth/UserSessionProvider'
import { requestCommentsQueryKey } from '@omnea-app/fe-comments/commentQueryKeys'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'

interface ResolveAmendmentRequestInput {
  commentIds: string[]
  requestFormId: string
}

export const useResolveAmendments = ({ requestId }: { requestId: string }) => {
  const { getToken } = useAuthenticatedUser()
  const isSupplier = useIsSupplierRole()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: ResolveAmendmentRequestInput) => {
      const apiClient = new CommentsHttpClient({ authorization: await getToken() })
      const { data, error } = await apiClient.POST(supplierPortalPath('/resolve-amendment-request', isSupplier), {
        body,
      })
      throwIfApiError(error)
      return data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [requestCommentsQueryKey, requestId] })
    },
  })
}
